export default __webpack_public_path__ + "5faef6a5afda4e2c37bc05679008395b.png";